export default "__VITE_ASSET__94e19563__"